import { reactive as o } from "vue";
import c from "./design-system.es120.js";
function i() {
  const e = o({
    messages: c
  });
  function t(s) {
    e.messages = s;
  }
  function r(s, n = {}) {
    return (e.messages[s] || s).replace(/\{(\w+)\}/g, (g, a) => n[a]);
  }
  return e.setMessages = t, e.t = r, e;
}
function p(e) {
  return e.provide("dsI18n", i());
}
export {
  i as createI18n,
  p as createI18nProvider
};
//# sourceMappingURL=design-system.es21.js.map
